import {axiosApiCallWithToken, axiosApiCall} from "../axios/customInstance";

export const submitProfileChangeRequest = async (staffId, changeData) => {
    const url = `/profileChangeRequest/${staffId}`;

    try {
        return await axiosApiCallWithToken.post(url, changeData);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getProfileChangeRequestByToken = async (token) => {
    const url = `/profileChangeRequest/review?token=${token}`;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const processProfileChangeRequest = async (token, decision, message = '') => {
    const url = `/profileChangeRequest/process`;
    
    const requestData = {
        token: token,
        decision: decision, // 'APPROVED' or 'REJECTED'
        message: message
    };

    try {
        return await axiosApiCallWithToken.post(url, requestData);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getPendingProfileChangeRequests = async () => {
    const url = `/profileChangeRequests/pending`;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const checkAuthenticationStatus = async () => {
    const url = `/profileChangeRequest/auth-check`;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};